import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/warning.svg'


const _hoisted_1 = { class: "picture-quality-error" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "picture-quality-img",
  src: _imports_0,
  alt: "warning"
}, null, -1)
const _hoisted_3 = { class: "picture-quality-text t-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.hasError.get('documentImage')), 1)
  ]))
}